import { useEffect, useState } from 'react';
import { voteUserService } from '../services/voteService';

/**
 * Count of open votes the member is eligible for and hasn't cast a ballot on yet
 * — powers the "Voting" nav badge. Fetches once when enabled; best-effort (0 on
 * error). Only runs when the voting feature is enabled to avoid a needless call.
 */
export function useOpenVotesCount(enabled: boolean): number {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return;
    }
    let active = true;
    voteUserService
      .listVotes()
      .then((votes) => {
        if (active) {
          setCount(votes.filter((v) => v.status === 'open' && !v.hasVoted).length);
        }
      })
      .catch(() => {
        /* leave at 0 */
      });
    return () => {
      active = false;
    };
  }, [enabled]);

  return count;
}

export default useOpenVotesCount;
